import { patientApiClient } from '../httpClient'

export const getEligibilityTransactions = async (
    skip: number,
    limit: number,
    activeOnly: boolean,
    destinationInterchangeId: string,
) => {
    let endpoint = `/api/v1/patient/eligibility/transactions?skip=${skip}&limit=${limit}&activeOnly=${activeOnly}&destinationInterchangeId=${destinationInterchangeId}`
    return await patientApiClient.get(endpoint)
}

export const getEligibilityTransaction = async (id: string) =>
    await patientApiClient.get(`/api/v1/patient/eligibility/transaction/${id}`)

export const getPatients = async (skip: number, limit: number, activeOnly: boolean) => {
    let endpoint = `/api/v1/patient?skip=${skip}&limit=${limit}&activeOnly=${activeOnly}`
    return await patientApiClient.get(endpoint)
}

export const getPatientById = async (personId: string) =>
    await patientApiClient.get(`/api/v1/patient/${personId}`)

export const verifyEligibility = async (payload: any): Promise<any> =>
    await patientApiClient.post(`/api/v1/patient/eligibility/validate`, payload)

export const submitEligibility = async (payload: any): Promise<any> =>
    await patientApiClient.post(`/api/v1/patient/eligibility`, payload)
